export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 80,
    slots: { default: 'opt' },
    className: 'col-opt',
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 80,
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'goodsName',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    minWidth: 220,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'amzSkuNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_scmName') || '执行工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFactory' },
  },
  {
    title: that.$l('table_label_amzPurchaseNo') || '采购单号',
    field: 'amzPurchaseNo',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_purchaseDate') || '采购日期',
    field: 'purchaseDate',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amzPurchaseStatus') || '单据状态',
    field: 'amzPurchaseStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_isAllShipments') || '是否出货完成',
    field: 'isAllShipments',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    slots: { default: 'displayIsAllShipments' },
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_purchasePrice') || '采购单价',
    field: 'purchasePrice',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subAmount') || '金额小计',
    field: 'subAmount',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_purchaseQty') || '采购数量',
    field: 'purchaseQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_shippedQty') || '已出货数量',
    field: 'shippedQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_productionQuantity') || '生产中数量',
    field: 'productionQuantity',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_shortageQuantity') || '短装数量',
    field: 'shortageQuantity',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_invQty') || '可出货数量',
    field: 'invQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_invCtnCbm') || '可出货总箱体积',
    field: 'invCtnCbm',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_buyerName') || '采购人员',
    field: 'buyerName',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
  },
]
